export const containerMaxW = "xl:max-w-7xl xl:mx-auto";

export const googleMapsApiKey = "AIzaSyCqBqYD2QbwpKp8j6tEaEMQfVQJUD8eDlg";
